/**
 * PasteFieldsChecklist — choose which parts of the copied recipe to apply.
 * Unchecked fields are omitted from the upsert, so the target keeps its value.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { Checkbox } from '@/components/ui';
import type { PasteFieldKey } from '../optimizer-clipboard.types';

const FIELDS: ReadonlyArray<{ key: PasteFieldKey; label: string }> = [
  { key: 'mode', label: 'Optimisation mode' },
  { key: 'formula', label: 'Scoring formula' },
  { key: 'excludeRules', label: 'Exclusion & capacity rules' },
  { key: 'interval', label: 'Run interval' },
  { key: 'weights', label: 'Min / max weight' },
  { key: 'package', label: 'Package attribution' },
];

export interface PasteFieldsChecklistProps {
  selected: Set<PasteFieldKey>;
  onToggle: (key: PasteFieldKey) => void;
  /** Source has a package — without one the attribution row is meaningless. */
  hasPackage: boolean;
}

export const PasteFieldsChecklist: FC<PasteFieldsChecklistProps> = ({
  selected,
  onToggle,
  hasPackage,
}) => (
  <div>
    <p className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
      Apply to each target
    </p>
    <ul className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2">
      {FIELDS.filter(({ key }) => key !== 'package' || hasPackage).map(({ key, label }) => (
        <li key={key}>
          <label className="flex cursor-pointer items-center gap-2 text-sm">
            <Checkbox
              checked={selected.has(key)}
              onCheckedChange={() => onToggle(key)}
              aria-label={label}
            />
            {label}
          </label>
        </li>
      ))}
    </ul>
  </div>
);
